import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { IconVideo } from '@fabric-app/icons/old';
import { isResourceDetailVideo } from '../../../../utils/resourceDetailGuards.js';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Image } from '@fabric-app/ui/components/Image';
import { FileIcon } from '@fabric-app/icons/icons';

const ResourcePreviewListItemStoredFile = () => {
  const { resource, placeholderName } = useResourceDataContextSafe();
  const { thumbnail } = resource;
  return /* @__PURE__ */ jsx(Wrapper, {
    children: thumbnail ? /* @__PURE__ */ jsxs(ThumbnailWrapper, {
      children: [
        isResourceDetailVideo(resource) && /* @__PURE__ */ jsx(IconContainer, {
          children: /* @__PURE__ */ jsx(IconVideo, {})
        }),
        /* @__PURE__ */ jsx(ThumbnailImage, {
          src: thumbnail.sm,
          alt: resource.name || placeholderName
        })
      ]
    }) : /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx(FileIcon, {
        height: 32,
        width: 32,
        extension: resource.extension || "?"
      })
    })
  });
};
const ThumbnailImage = styled(Image).withConfig({
  displayName: "ResourcePreviewListItemStoredFile__ThumbnailImage",
  componentId: "sc-7453060b-0"
})([
  `height:auto;width:auto;max-width:32px;max-height:24px;object-fit:scale-down;display:block;border-radius:0;`
]);
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewListItemStoredFile__Wrapper",
  componentId: "sc-7453060b-1"
})([
  `width:100%;height:100%;display:flex;flex-direction:column;gap:1rem;flex-grow:1;overflow:hidden;justify-content:center;align-items:center;`
]);
const IconContainer = styled.div.withConfig({
  displayName: "ResourcePreviewListItemStoredFile__IconContainer",
  componentId: "sc-7453060b-2"
})([
  `position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:3rem;width:3rem;display:flex;align-items:center;justify-content:center;svg{height:1rem !important;width:1rem !important;}`
]);
const ThumbnailWrapper = styled.div.withConfig({
  displayName: "ResourcePreviewListItemStoredFile__ThumbnailWrapper",
  componentId: "sc-7453060b-3"
})([
  `position:relative;border:1px solid rgba(`,
  `,0.06);border-radius:0.25rem;overflow:hidden;`
], cssVar["color-text-primary-rgb"]);

export { ResourcePreviewListItemStoredFile };
//# sourceMappingURL=ResourcePreviewListItemStoredFile.js.map
